import { render } from "./index.vue?vue&type=template&id=58579156&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=58579156&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-58579156"

export default script